import React from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/paau-asensio/30min';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const HeroSection = ({ t }) => (
  <section id="inicio" className="relative pt-16 pb-20 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700">
      <div className="absolute inset-0 bg-black/20"></div>
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwdGVhbXxlbnwwfHx8fDE3NTc1MjkyMzh8MA&ixlib=rb-4.1.0&q=85')`,
        }}
      ></div>
    </div>

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16">
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          {t.hero.title} <span className="text-blue-300">{t.hero.titleHighlight}</span>
          {t.hero.titleEnd}
        </h1>
        <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-4xl mx-auto leading-relaxed">{t.hero.subtitle}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-all transform hover:scale-105 flex items-center justify-center gap-2 shadow-lg"
            data-testid="hero-cta-audit-btn"
          >
            <ArrowRight className="w-5 h-5" />
            {t.hero.ctaAudit}
          </a>
          <button
            onClick={() => scrollTo('precios')}
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-900 transition-all flex items-center justify-center gap-2"
            data-testid="hero-cta-pricing-btn"
          >
            {t.hero.ctaPricing}
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>

    <div className="absolute bottom-0 left-0 right-0">
      <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,64L80,69.3C160,75,320,85,480,85.3C640,85,800,75,960,64C1120,53,1280,43,1360,37.3L1440,32V120H1360C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120H0V64Z" fill="white" />
      </svg>
    </div>
  </section>
);

export default HeroSection;
